// extracted by mini-css-extract-plugin
export default {"Label":"_Label--EEAXh","InfoIcon":"_InfoIcon--mh6f2"};